import { apiClient } from "../../utils/apiClient";

export function getAccessToken(roomId: string, token: string| undefined): Promise<{ data: { token: string } }> {
	return apiClient("twilio/access-token", {
		data: {
			roomId,
		},
		token,
	});
}
